module.exports = __webpack_public_path__ + "assets/webgl/360_vignes.jpg.etc.a636af43.ktx";